import * as initIxLib from '../../../assets/ixLib'
import WebModel from '../../models/WebModel'
import Blacklist from '../../blacklist/Blacklist'

export const IndexExchange = {
  init({ indexExchange }: WebModel, { all }: Blacklist) {
    if (!indexExchange || all) {
      return
    }
    initIxLib()
  }
}
